import {
  type MediaCardType,
  mediaCardTypeToKeys,
} from '@wandb/weave/common/types/media';

/**
 * Media card types the media settings drawer can render settings for.
 *
 * Panels of any other card type (html, plotly, bokeh, molecule) use the
 * settings popup instead, so this is what the drawer's entry points gate on and
 * what its metric search filters to.
 *
 * Moved out of `useGetIsMediaPanelSettingsDrawerSupportedForPanel` because the
 * settings menus and the metric search hook need it too, and importing it from
 * there drags a hook into modules that only want the list.
 */
export const SUPPORTED_MEDIA_DRAWER_TYPES: MediaCardType[] = [
  'image',
  'video',
  'audio',
  'object3D',
];

/**
 * The wire values behind those card types.
 *
 * `mediaStrings` covers every media type the app knows, including ones no media
 * card renders. This is the subset a supported panel could actually hold, so it
 * is what the drawer's queries filter on.
 */
export const SUPPORTED_MEDIA_DRAWER_TYPE_STRINGS =
  SUPPORTED_MEDIA_DRAWER_TYPES.flatMap(mediaCardTypeToKeys) as string[];
